export const OPTHINES = {
  voteName: '2020project/2020chongqing_beautiful_one',
  number: {
    mustRank: true,
  },
  themeColor: {
    activeBgColor: '#9c4896',
    inactiveBgColor: '#bcbcbc',
  },
  tabs: [
    {
      tabName: '活动介绍',
      tabPath: '/20200717ZJB/Rules',
    },
    {
      tabName: '历届大赛概况',
      tabPath: '/20200717ZJB/PreView',
    },
    {
      tabName: '报名表下载',
      tabPath: '/20200717ZJB/Download',
    },
  ],
};
